import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--cart-signin"
export default class extends Controller {
    connect() {
        console.log('CartSigninController connected');
        this.initializeValidation();
    }

    initializeValidation() {
        const form = document.getElementById('frm-checkout-login');
        if (!form) {
            console.error('Checkout login form element not found');
            return;
        }

        // Save the validation instance to this.validation
        this.validation = formValidation(form, {
            fields: {
                'user[email]': {
                    validators: {
                        notEmpty: {
                            message: 'Email address is required'
                        },
                        emailAddress: {
                            message: 'Please enter a valid email address'
                        }
                    }
                },
                'user[password]': {
                    validators: {
                        notEmpty: {
                            message: 'Password is required'
                        },
                        stringLength: {
                            min: 6,
                            message: 'Password must be at least 6 characters long'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.form-floating',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid'
                })
            }
        }).on('core.form.valid', function (e) {
            // Use requestSubmit() instead of submit() to work with Turbo
            form.requestSubmit();
        })
            .on('core.form.invalid', function (e) {
                // console.log('Form is invalid!');
            });
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }
    }
}
